<template>
    <div :class="showLogo ? 'menuList' : ''">
        <v-overlay v-if="loading" color="white">
            <v-progress-circular indeterminate/>
        </v-overlay>
        <div >

            <div v-if="showLogo" class="logo">
                <router-link :to="{path:'/'}">
                    <img class="ma-6 mt-5" style="max-width: 100%;height:auto;" alt="logo" :src="logoPath" />
                </router-link>
            </div>
            <v-list-item-group>
                <v-list nav>
                    <v-list-item :to="{path: element.path}"
                                 @click="$emit('menuItemClicked', element)"
                                 :key="element.name" class="menuListItem"
                                 v-for="element in userRoutes">
                        <v-list-item-action>
                            <v-icon small>{{ element.meta.pageIcon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <div
                                v-if="element.meta.pageBadge && getBadge(element.meta.pageBadge.areaId)">
                                <v-badge
                                    :content="getBadge(element.meta.pageBadge.areaId).BADGETEXT"
                                    :color="getBadge(element.meta.pageBadge.areaId).COLOR" bordered>
                                    <v-list-item-title class="mr-2">
                                        {{ element.meta.pageTitle }}
                                    </v-list-item-title>
                                </v-badge>
                            </div>
                            <v-list-item-title v-else class="mr-2">
                                {{ element.meta.pageTitle }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-list-item-group>
            <v-divider/>
            <v-list-item-group>
                <v-list nav>
                    <div v-if="showLogOut">
                        <logout-dialog>
                            <template v-slot:open="{ on }">
                                <v-list-item inactive style="cursor: pointer;" v-on="on">
                                    <v-list-item-action>
                                        <v-icon small>ordermanager-logout</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Abmelden</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </logout-dialog>
                    </div>
                    <div v-else>
                        <v-list-item :ripple="true" active-class="primary white--text"
                                     :href="getCallerUrl()"
                                     @click="resetCaller">
                            <v-list-item-action>
                                <v-icon small>ordermanager-logout</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Schließen</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </div>
                </v-list>
            </v-list-item-group>
            <v-divider/>
            <slot name="addintionalMenuItems"></slot>
        </div>

    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {routes} from '@/router';
import LogoutDialog from '@/components/LogoutDialog.vue';
import {RouteConfig} from "vue-router";
import {globalEventBus} from "@/main";
import {ref, Ref} from "vue";

@Component({components: {LogoutDialog}})
export default class Menu extends Vue {


    private get logoPath():string{
        return this.$store.getters["Base/icon"];
    }

    @Prop({ default: ()=> false})
    private isLoggedIn!:boolean ;
    private loading: boolean = true;
    @Prop()
    private userConfig!: any;
    private badges: { APPID: string, APPAREA: string, COLOR: string, BADGETEXT: string, EXTENSIVETEXT: string }[] | undefined = undefined;
    private badgesTimer: NodeJS.Timer | undefined;

    @Prop({default: false})
    private showLogo!: boolean;
    private userRoutes: RouteConfig[] = [];


    private logoutApp() {
        if (this.showLogOut) {

            this.$store.commit("Auth/setAuthToken", '');
            this.resetCaller();
            this.$ports.b2bAuth.logout();
        } else {
            this.resetCaller();
        }
    }


    async mounted() {


        globalEventBus.$on("refreshBadges", this.checkBadges);
        await this.setRoutes();
        await this.refreshBadges();


    }

    @Watch('userConfig')
    private async setRoutes(): Promise<void> {
        try {
            this.loading = true;
            this.userRoutes = [];
            routes.forEach((r) => {
                if (r.path == "/artikel") {
                    if (this.userConfig.permissions.COMMON.ARTIKEL === 1) {
                        this.userRoutes.push(r);
                    }
                } else if (r.path === "/kunden") {
                    if (this.userConfig.permissions.COMMON.KUNDEN === 1) {
                        this.userRoutes.push(r);
                    }
                } else if (r.path === "/berichte") {
                    if (this.userConfig.permissions.COMMON.REPORTS === 1) {
                        this.userRoutes.push(r);
                    }
                } else if (r.path === "/stammdaten") {

                    if (this.userConfig.permissions.COMMON.STAMMDATEN === 1) {
                        this.userRoutes.push(r);
                    }
                } else {
                    this.userRoutes.push(r);
                }
            });
        } catch (e: any) {

        } finally {
            this.loading = false;
        }
    }

    private async refreshBadges(): Promise<void> {
        this.$forceUpdate();
        await this.checkBadges();
    }

    private async checkBadges(): Promise<void> {
        // if (this.badgesTimer) {
        //     window.clearTimeout(this.badgesTimer);
        // }
        // const badges = await this.$ports.orderManager.getBadges("APRO.ORDER");
        // this.badges = badges;
        // this.$forceUpdate();
        // this.badgesTimer = setTimeout(this.checkBadges, 1000 * 10);

    }

    private get showLogOut(): boolean {
        return !this.$store.getters["Base/caller"];
    }

    private resetCaller(): void {
        this.$store.commit("Base/setCaller", "");
    }

    private getCallerUrl() {
        let caller = this.$store.getters['Base/caller'];
        if (!caller) {
            return "#";
        }
        const bid = this.$ports.auth.getBranchId();
        if (bid && Number.parseInt(bid) > 0) {
            return caller + decodeURIComponent("?bid=" + this.$ports.auth.getBranchId());
        }
        return caller;
    }

    public getBadge(areaId: string): any {
        // console.log(areaId);
        if (this.badges && this.badges.length > 0) {
            return this.badges.find((b) => b.APPAREA === areaId);
        }
        return null;
    }

    unmounted() {
        globalEventBus.$off("refreshBadges");
        if (this.badgesTimer) {
            clearTimeout(this.badgesTimer);
        }
    }
}
</script>

<style>
#app .menuListItem .v-list-item__content {
    overflow: visible;
}
</style>
